<template
  ><v-expansion-panel @click="toggleLayer">
    <v-expansion-panel-header>
      <template v-slot:default="{ open }">
        <v-checkbox
          :value="open"
          :input-value="open"
          label="Currents"
          class="menu-checkbox"
        ></v-checkbox>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-select label="Datetime" :items="currents_dates" v-model="active_date">
        <v-icon
          slot="prepend"
          :disabled="disableNextButton"
          @click="nextDate(active_date, currents_dates)"
          >mdi-menu-left</v-icon
        >
        <v-icon
          slot="append-outer"
          :disabled="disablePreviousButton"
          @click="previousDate(active_date, currents_dates)"
          >mdi-menu-right</v-icon
        >
      </v-select>
      <p>
        The Operational Mercator global ocean analysis and forecast system at
        1/12 degree is providing 10 days of 3D global ocean forecasts updated
        daily. The time series start on January 1st, 2016 and is aggregated in
        time in order to reach a two full year’s time series sliding window.
        This product includes daily and monthly mean files of temperature,
        salinity, currents, sea level, mixed layer depth and ice parameters from
        the top to the bottom over the global ocean. It also includes hourly
        mean surface fields for sea level height, temperature and currents. The
        global ocean output files are displayed with a 1/12 degree horizontal
        resolution with regular longitude/latitude equirectangular projection.
      </p>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import MapServices from "@/services/mapbox.service";

export default {
  name: "currentsExpansionPanel",
  data: () => ({
    layer_active: false,
    active_date: "2020-10",
    currents_dates: [
      "2020-10",
      "2020-09",
      "2020-08",
      "2020-07",
      "2020-06",
      "2020-05",
      "2020-04",
      "2020-03",
      "2020-02",
      "2020-01",
      "2019-12",
      "2019-11",
      "2019-10",
      "2019-09",
      "2019-08",
      "2019-07",
      "2019-06",
      "2019-05",
      "2019-04",
      "2019-03",
      "2019-02",
      "2019-01",
      "2018-12",
      "2018-11",
      "2018-10",
      "2018-09",
      "2018-08",
      "2018-07",
      "2018-06",
      "2018-05",
      "2018-04",
      "2018-03",
      "2018-02",
      "2018-01"
    ],
    currents_added: []
  }),
  computed: {
    disableNextButton() {
      return (
        this.currents_dates.indexOf(this.active_date) ===
        this.currents_dates.length - 1
      );
    },
    disablePreviousButton() {
      return this.currents_dates.indexOf(this.active_date) === 0;
    },
    layerName() {
      return `currents_${this.active_date}_layer`;
    }
  },
  methods: {
    toggleLayer() {
      if (this.layer_active) {
        MapServices.removeLayer(this.layerName);
        this.layer_active = false;
      } else {
        MapServices.loadAddCurrentLayer(this.active_date);
        this.layer_active = true;
      }
    },
    nextDate(selectedElement, selection) {
      const selectedPeriodIndex = selection.indexOf(selectedElement);
      if (selectedPeriodIndex < selection.length - 1) {
        this.active_date = selection[selectedPeriodIndex + 1];
      }
    },
    previousDate(selectedElement, selection) {
      const selectedPeriodIndex = selection.indexOf(selectedElement);
      if (selectedPeriodIndex > 0) {
        this.active_date = selection[selectedPeriodIndex - 1];
      }
    }
  },
  watch: {
    active_date(date_string, old_date) {
      MapServices.removeLayer(`currents_${old_date}_layer`);
      MapServices.loadAddCurrentLayer(date_string);
    }
  }
};
</script>

<style scoped>
.menu-checkbox {
  height: 30px;
  padding: 0;
  margin: auto 0;
}
</style>
